import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const createPixelModalSelector = createSelector(modalsSelector, (modals) => modals.createPixel);

export default createPixelModalSelector;
